import React, { useEffect, useState } from "react";
import "./contact.css";
import { ValidationError, useForm } from "@formspree/react";
import Lottie from "lottie-react";
import doneAnimation from "../../animation/done.json";
import contactAnimation from "../../animation/contact2.json";

const circularReplacer = () => {
  const seen = new WeakSet();
  return (key, value) => {
    if (typeof value === "object" && value !== null) {
      if (seen.has(value)) {
        return;
      }
      seen.add(value);
    }
    return value;
  };
};

const Contact = () => {
  const [state, handleSubmit] = useForm("mkndjbqn");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const onChangeEmail = (e) => {
    setEmail(e.target.value);
  };

  const onChangeMessage = (e) => {
    setMessage(e.target.value);
  };

  useEffect(() => {
    if (state.submitting) {
      setEmail("");
      setMessage("");
    }
  }, [state]);

  const doneAnimNew = JSON.stringify(doneAnimation, circularReplacer());
  const contactAnimationNew = JSON.stringify(
    contactAnimation,
    circularReplacer()
  );

  return (
    <section id="contact" className="contact-us">
      <h1 className="title">
        <span className="icon-envelope"> </span>
        Contact us
      </h1>
      <p className="sub-title">
        Contact us for more information and Get notified when I publish
        something new.
      </p>

      <div style={{ justifyContent: "space-between" }} className="flex">
        <form onSubmit={handleSubmit} itemScope>
          <div className="flex">
            <label htmlFor="email">Adresse e-mail :</label>
            <input
              autoComplete="off"
              required
              type="email"
              value={email}
              name="email"
              id="email"
              onChange={onChangeEmail} 
              itemProp="contactPoint"
            />
            <ValidationError
              prefix="Email"
              field="email"
              errors={state.errors}
              replacer={circularReplacer()}
            />
          </div>

          <div className="flex" style={{ marginTop: "24px" }}>
            <label htmlFor="message">Votre message :</label>
            <textarea
              required
              name="message"
              value={message}
              id="message"
              onChange={onChangeMessage} 
              itemProp="text"
            ></textarea>
            <ValidationError
              prefix="Message"
              field="message"
              errors={state.errors}
              replacer={circularReplacer()}
            />
          </div>

          <button type="submit" disabled={state.submitting} className="submit">
            {state.submitting ? "Envoi en cours..." : "Envoyer"}
          </button>

          {state.succeeded && (
            <p
              className="flex successfully"
              style={{ fontSize: "18px", marginTop: "1.7rem" }}
            >
              <Lottie
                loop={false}
                style={{ height: 37 }}
                animationData={JSON.parse(doneAnimNew)}
              />
              Votre message a été envoyé avec succès 👌
            </p>
          )}
        </form>
        <div className="animation">
          <Lottie
            className="contact-animation"
            style={{ height: 355 }}
            animationData={JSON.parse(contactAnimationNew)}
          />
        </div>
      </div>
    </section>
  );
};

export default Contact;